import { inject, InjectionToken } from "@angular/core";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SoftwareProduct } from "src/app/support/product";

export type SentryConfig = {
  requestHeaderLocation: string;
  requestHeaderVersion: string;
};

export const SENTRY_CONFIG_TOKEN = new InjectionToken<SentryConfig>(
  "sentry_config",
  {
    providedIn: "root",
    factory: () => {
      switch (inject(PRODUCT_TOKEN)) {
        case SoftwareProduct.PMS:
        case SoftwareProduct.ROCKET:
        case SoftwareProduct.SNOOTS:
        case SoftwareProduct.ADMIN:
        case SoftwareProduct.PLATFORM:
        case SoftwareProduct.DROP_PAGE: {
          return {
            requestHeaderLocation: "x-snt-location",
            requestHeaderVersion: "x-snt-version"
          };
        }
        case SoftwareProduct.BOTMASTER: {
          return {
            requestHeaderLocation: "x-dzl-location",
            requestHeaderVersion: "x-dzl-version"
          };
        }
      }
    }
  }
);
